import "./postDone.css";

export const KooPostDone = () => {
  return (
    <div className="koo-posted-div">
      <h2 cklassName="koo-post heading">Koo Posted</h2>
      <img src="/assets/create-post-icons/koo_posted.svg" alt="Koo Posted" />
    </div>
  );
};
